<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;color: #654727;">传道授业，共同成长</p>

        <p class="font2" style="padding-top: 4vh;" v-if="ReportData.lesson">2023年您的线下授课时数共计<a class="font3">{{ this.totalHours }}</a>小时：</p>

        <p class="font2" style="padding-top: 2vh;"  v-for="(char, index) in lessonArray" :key="index">
            <a class="font3">{{ char.class_type }}</a>类课程
            <a class="font3">{{ char.class_num }}</a>门
            <a class="font3">{{ char.hours }}</a>小时，
            <a class="font3">{{ char.student_num }}</a>人参与
        </p>

        <p class="font2" style="padding-top: 4vh;">讲师课程推荐：</p>
        <div style="width: 80%;margin: 0 auto;margin-top: 1vh;">
            <ul v-for="(item,index) in bookList" :key="index">
                <li @click="redirectToRecommendBook(index)">{{item.name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
            </ul>
        </div>

        <p class="font2" style="padding-top: 4vh;margin: 0;">你的每一份付出都在传递智慧与力量</p>
        <p class="font2" style="margin: 0;">知识传播是一种美德</p>
        <p class="font2" style="margin: 0;">不仅成就了他人</p>
        <p class="font2" style="margin: 0;">而且提升了自己</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data(){
        return{
            lessonArray:[],
            totalHours:0,
            classType:'',
            sutdentNum:0,
            bookList:[
                {id:1,name:'从零开始使用ChatGpt',link:'https://iedu.foxconn.com/public/play/playCourse?courseId=39658'},
                {id:2,name:'ChatGPT提示词工程',link:'https://iedu.foxconn.com/public/play/playCourse?courseId=45148'},
                {id:3,name:'ChatGPT秘技揭秘',link:'https://iedu.foxconn.com/public/play/playCourse?courseId=48746'}
            ]
        }
    },
    created() {
        this.lessonArray = JSON.parse(this.ReportData.lesson)
        // console.log(this.lessonArray,'课程')
        this.lessonArray.forEach(element => {
        this.totalHours+=parseInt(element.hours)
        });
    },
    methods:{
        redirectToRecommendBook(id){
            
            const book=this.bookList[id]
            console.log(book);
            // const url=book.link
            const view={
                clickCourseName:book.name,
                clickCourseLink:book.link
            }
            this.$emit('redirectToRecommendBook',view)  
        },
    }
}
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24August/logo.png") right  top  no-repeat,
                /* url("../../assets//24August/icon.png") 49% calc(100% + 70px) no-repeat, */
                url("../../assets/24August/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    /* text-align: center; */
}
li {
    align-items: center;
    margin-bottom: -13px; /* 可调整列表项之间的间距 */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 20px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 92%;
    padding-left: 8%;
    margin: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    color: #654727;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  </style>